export enum EvenFormDynamicFieldAction {
  noAction = 0,
  hide = 1,
  show = 2,
  addMessage = 3,
}

export interface EvenFormDynamicFieldStatus {
  statusChange: EvenFormDynamicFieldAction;
  customStatusData?: any;
}

export interface EventFormDynamicField {
  fieldName: string;
  rules: EvenFormDynamicFieldStatus[];
}



// WEBPACK FOOTER //
// ./src/app/admin/events-screen/event-page-models/event-form-dynamic-field.ts